import { render, staticRenderFns } from "./BlockType11Grid.vue?vue&type=template&id=58c5e080&scoped=true&"
import script from "./BlockType11Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType11Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType11Grid.vue?vue&type=style&index=0&id=58c5e080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5e080",
  null
  
)

export default component.exports